import React from 'react';

const ShareLinks = ({ problem }) => {
  // If there's no problem, don't render the share links.
  if (!problem || !problem.trim()) {
    return null;
  }

  // The text that will appear in the body of the social media post
  const shareText = `Check out these provocations for the problem: "${problem}" - from ProvocaBot`;
  const encodedText = encodeURIComponent(shareText);

  // The base URL of the application
  const baseUrl = window.location.origin;
  // The full URL to share, including the problem as a query parameter
  const fullUrl = `${baseUrl}?problem=${encodeURIComponent(problem)}`;
  // The full URL, encoded for use within another URL's query string
  const encodedUrl = encodeURIComponent(fullUrl);

  const shareLinks = [
    {
      name: 'X/Twitter',
      url: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}`,
    },
    {
      name: 'Facebook',
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    },
    {
      name: 'Reddit',
      url: `https://www.reddit.com/submit?url=${encodedUrl}&title=${encodedText}`,
    },
    {
      name: 'LinkedIn',
      url: `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedText}`,
    },
  ];

  return (
    <div className="mt-8 text-center">
      <ul className="list-none p-0 flex justify-center gap-4">
        {shareLinks.map((link) => (
          <li key={link.name}>
            <a href={link.url} target="_blank" rel="noopener noreferrer" className="inline-block bg-secondary-600 hover:bg-secondary-700 !text-black dark:bg-secondary-500 dark:hover:bg-secondary-600 dark:text-white px-4 py-2 rounded no-underline font-bold transition-colors">
              {link.name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ShareLinks;
